// extracted by mini-css-extract-plugin
export var closeButton = "_gx-2";
export var closeButtonIcon = "_gx-3";
export var lightboxContent = "_gx-1";
export var lightboxOverlay = "_gx-0";